<template>
  <div class="dashboard-editor-container">

    <panel-group />
    <line-row />
    <el-row :gutter="8">
      <el-col :xs="{span: 24}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 16}" :xl="{span: 16}" style="padding-right:8px;margin-bottom:30px;">
        <transaction-table />
      </el-col>
      <el-col :xs="{span: 24}" :sm="{span: 12}" :md="{span: 12}" :lg="{span: 8}" :xl="{span: 8}" style="margin-bottom:30px;">
        <!-- <box-card /> -->
        <bar-graph />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import PanelGroup from './components/PanelGroup'
import LineRow from './components/LineRow'
import TransactionTable from './components/TransactionTable'
import BarGraph from './components/BarGraph'

export default {
  name: 'DashboardAdmin',
  components: {
    PanelGroup,
    TransactionTable,
    LineRow,
    BarGraph
  },
  data() {
    return {
      
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  height: calc(100vh - 50px);
  overflow-y: scroll;
  padding: 32px;
  // background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
</style>
